var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current_attachment"},[_c('a',{attrs:{"aria-label":"View File","target":"_blank","href":_vm.url}},[_vm._v("View Attachment #"+_vm._s(_vm.num))]),_vm._v(" "),_c('a',{staticClass:"text-danger delete_attachment",attrs:{"href":"#"},on:{"click":function($event){return _vm.deleteAttachment($event)}}},[_vm._v("Delete")])])
}
var staticRenderFns = []

export { render, staticRenderFns }